export enum ReportingPageName {
  Dashboard = 'dashboard',
  PostingList = 'posting-list',
  PositionList = 'position-list',
  CampaignList = 'campaign-list',
  CampaignDetails = 'campaign-details',
  Candidates = 'candidates',
  CandidateList = 'candidate-list',
  CandidateMatch = 'candidate-match',
  CandidateDetails = 'candidate-details',
  PreviousApplicants = 'previous-applicants',
  Interviews = 'interviews',
  InterviewAvailability = 'interview-availability',
  InterviewsScheduled = 'interviews-scheduled',
  VideoInterview = 'video-interview',
  CareerSites = 'career-sites',
  UserInformation = 'user-information',
  UserList = 'user-list',
  UserRoleList = 'user-role-list',
  FeaturedEmployer = 'featured-employer',
  FeedList = 'feed-list',
  FeedDetails = 'feed-details',
  Billing = 'billing',
  BrandList = 'brand-list',
  LocationList = 'location-list',
  Audit = 'audit',
  Notifications = 'notifications',
  SignOut = 'sign-out',
  SelfSignUp = 'self-sign-up',
  DownloadAppLandingPage = 'download-app',
  CampaignPerformance = 'campaign-performance',
  PostingPerformance = 'posting-performance',
  // Job Posting Steps for Self Signup users
  CreatePostingLocation = 'create-new-posting-location',
  CreatePostingJob = 'create-new-posting-job',
  CreatePostingPay = 'create-new-posting-pay',
  CreatePostingQualifications = 'create-new-posting-qualifications',
  CreatePostingDescription = 'create-new-posting-description',
  CreatePostingReview = 'create-new-posting-review',
  CreatePostingSuccess = 'create-new-posting-success',
  // Employer self-service transactional registration flow
  SignUpEmail = 'sign-up-email',
  SignUpVerify = 'sign-up-verify',
  SignUpBasicInfo = 'sign-up-basic-info',
  SignUpBusinessInfo = 'sign-up-business-info',
  SignUpComplete = 'sign-up-complete',
}
